module.exports = "fragment CustomCardFragment on Card {\n  __typename\n  id\n  frontPreviewUrl(width: 320, fitIn: true)\n  isHorizontal\n}\n"